import { NgModule } from '@angular/core';
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { authReducer } from './store/reducers/auth.reducer';
import { AuthEffects } from './store/effects/auth.effects';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiAuthInterceptor } from './services';
import { LoginComponent } from './login/login.component';
import { RouterModule } from "@angular/router";
import { LoggedInGuard } from './guards';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'login',
                canActivate: [LoggedInGuard],
                pathMatch: 'full',
                data: { showNav: false },
                component: LoginComponent
            }
        ]),
        StoreModule.forFeature('auth', authReducer),
        EffectsModule.forFeature([
            AuthEffects
        ])
    ],
    declarations: [
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ApiAuthInterceptor, multi: true }
    ]
})
export class InternalAuthModule { }